// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PostImage-overlay__e751a14a315eac050254{--yarl__color_backdrop: rgb(0 0 0 / 0.85)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": "PostImage-overlay__e751a14a315eac050254"
};
export default ___CSS_LOADER_EXPORT___;
